import {LOCALIZATION} from "../index";

export const setLocalization = (lng) => async dispatch => {
    dispatch({
        type: LOCALIZATION,
        payload: {lng}
    });

};